export default __webpack_public_path__ + "static/media/0w20.1d8c3283.png";